import {
	PAYMENT_HOST_CODES,
	RESOLVED_TRANSACTION_STATUS_CODES,
} from '../constants/transactionCodes.js';

export function isJpmNotificationRecoveryEligible(row) {
	return !!row &&
		row.payHostCode === PAYMENT_HOST_CODES.JPM &&
		!RESOLVED_TRANSACTION_STATUS_CODES.includes(row.statusCode);
}
